import React, {Component} from 'react';
import {Icon, message, Modal, Upload} from 'antd';

class Photos extends Component {
  state = {
    previewVisible: false,
    previewImage: '',
    fileList: []
  };

  handleChange = ({file}) => {
    // console.log(file.originFileObj);
    if(file && file.originFileObj)
      this.props.uploadLeasePhoto(file.originFileObj);
  }

  handleRemove = (file) => {
    this.props.removeLeasePhoto(file.uid)
  };

  componentDidMount = () => {
    this.setState({
      fileList: this.props.images
    });

    // const images = this.props.images;
    // if(images && images.length > 0) {
    //   this.setState({
    //     fileList:
    //       images.map(image => {
    //         if(image.file) {
    //           return {
    //             uid: image._id,
    //             name: image.name,
    //             status: 'done',
    //             url: image.file.path,
    //           }
    //         }
    //       })
    //   });
    // }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // console.log(this.props, nextProps)
    // console.log(nextProps.uploadedPhoto, this.props.uploadedPhoto)
    if(nextProps && nextProps.uploadedPhoto != this.props.uploadedPhoto) {
      const files = this.state.fileList || [];
      if(nextProps.uploadedPhoto) {
        files.push({
          uid: nextProps.uploadedPhoto._id,
          name: nextProps.uploadedPhoto.name,
          status: 'done',
          url: nextProps.uploadedPhoto.file.path,
        });
        this.setState({
          fileList: files
        })
      }
    } else if(nextProps && nextProps.isPhotoRemoved != this.props.isPhotoRemoved) {
      const files = this.state.fileList || [];
      if(nextProps.isPhotoRemoved) {
        const newFiles = files.filter(im => im.uid !== nextProps.isPhotoRemoved)
        this.setState({
          fileList: newFiles
        })
      }
    }else {
      //console.log(this.props, nextProps)
    }
  }

  render() {
    const {fileList, previewVisible, previewImage} = this.state;
    const uploadButton = (
      <div>
        <Icon type="plus"/>
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    return (
      <div>
        <Upload
          listType="picture-card"
          fileList={fileList}
          // onPreview={this.handlePreview}
          onChange={this.handleChange}
          onRemove={this.handleRemove}
          beforeUpload={(file) => {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            if(!isJPG) {
              message.error('You can only upload JPG or PNG file!');
              return false;
            } else {
              return true;
            }
          }}
        >
          {fileList.length >= 10 ? null : uploadButton}
        </Upload>
        <Modal visible={previewVisible} footer={null} onCancel={null}>
          <img alt="example" style={{width: '100%'}} src={previewImage}/>
        </Modal>
      </div>
    );
  }
}


export default Photos;
